import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("label", null, "Cerca indirizzo", -1)),
    _withDirectives(_createElementVNode("input", {
      type: "search",
      ref: "autocomplete",
      class: "form-control",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitModel(_ctx.localValue))),
      autocomplete: "chrome-off",
      placeholder: "Enter a location"
    }, null, 544), [
      [_vModelText, _ctx.localValue]
    ])
  ]))
}